import EventBase from "./EventBase";
import EventSeniorIf from "./EventSeniorIf";
import EventText from "./EventText";
import EventTextDifEx from "./EventTextDifEx";
import EventTextDifEx2 from "./EventTextDifEx2";

/**
 * @author ysxx
 * @email [yishuiwy@163.com]
 * @Version v1.0.0
 * @create date 2021-12-23 15:47:11
 * @modify date 2021-12-23 15:47:11
 * @Copyright @ 北京六趣网络科技有限公司 2022. All rights reserved. 
 * @desc 生成具体事件
 */
class EventMaker {

    public static maker(nobj:any):EventBase{
        if (nobj instanceof EventText) {
            if (nobj.Parameter.length >= 17) {
                nobj.Extra = nobj.Parameter[16]
            }
            if (nobj.Parameter.length >= 18) {
                nobj.FilmEffect = nobj.Parameter[17]
            }
            if (nobj.Parameter.length >= 19) {
                nobj.Index = parseInt(nobj.Parameter[18])
            }
        }
        if (nobj instanceof EventSeniorIf) {
            nobj.InitIfItems()
        }
        if (nobj instanceof EventTextDifEx) {
            nobj.SetShowConditionInit()
        }
        if (nobj instanceof EventTextDifEx2) {
            nobj.SetPersonlInit()
            nobj.SetShowConditionInit()
        }
        return nobj
    }

}
export default EventMaker
